import { useContext } from 'react'
import { HermesSdkContext } from './hermes-sdk-context'

export const useHermesSdkConfig = () => {
  const { tenant, accessToken } = useContext(HermesSdkContext) || {}

  if (!tenant) {
    throw new Error('Tenant is not set in HermesSdkProvider')
  }

  return { tenant, accessToken }
}
